import type { Localization } from '@/app/components/search/common/Localization';

export const RESULT_PAGE_FILTER_NO_RESULT = 'RESULT_PAGE_FILTER_NO_RESULT';
export const RESULT_PAGE_FILTER_NO_RESULT_VERSION = '1.0';

export type ResultPageFilterNoResultParams = {
  searchId: string;
  localization: Localization;
};

export type ResultPageFilterNoResultPayload = {
  searchId: string;
};

export const createResultPageFilterNoResultPayload = (
  params: ResultPageFilterNoResultParams
): ResultPageFilterNoResultPayload => {
  const { searchId } = params;

  const payload = {
    searchId,
  };

  return payload;
};
